import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		TOKEN: window.sessionStorage.getItem('token'),
		NEWS_SHOW: false,   // 新闻板块显示状态
		GET_NEWS: false,    // 新闻板块发送请求的标志参数（参数发生改变就发送请求）
		FAQ_SHOW: false,    // faq板块显示状态
		LOGO_SHOW: true,    // logo显示状态
		TOPNAVBTN_INDEX: window.sessionStorage.getItem("topNavBtn_index") || 1,	// topNav当前高亮显示标志参数
		SPECIALDETAIL_SHOW: false,	// special_detail显示状态
		TOUCH_TIP_SHOW: true,	// 看板娘touch提示显示状态
		////////////////////////////////////////////////////////////////////////////////////////////////////////
		TYPE: 1,   // 不知道叫什么类型
		PAGE_INDEX_FROM: ''   //当前页
	},
	mutations: {
		LOGIN: (state, params) => {
			state.TOKEN = params.token
			window.sessionStorage.setItem('token', params.token)
			router.replace({
				path: router.currentRoute.query.redirect || 'admin',
				query: { username: params.username }
			})
		},
		LOGOUT: (state) => {
			state.TOKEN = null
			window.sessionStorage.removeItem('token')
			router.replace('login')
		},
		SET_NEWS_SHOW: (state, params) => {
			state.NEWS_SHOW = params
		},
		SET_GET_NEWS: (state) => {
			state.GET_NEWS = !state.GET_NEWS
		},
		SET_FAQ_SHOW: (state, params) => {
			state.FAQ_SHOW = params;
		},
		SET_LOGO_SHOW: (state, params) => {
			state.LOGO_SHOW = params;
		},
		SET_TOPNAVBTN_INDEX: (state, params) => {
			state.TOPNAVBTN_INDEX = params;
			window.sessionStorage.setItem('topNavBtn_index', params);
		},
		SET_NEWSDETAIL_SHOW: (state, params) => {
			state.SPECIALDETAIL_SHOW = params;
		},
		SET_TOUCH_TIP_SHOW: (state, params) => {
			state.TOUCH_TIP_SHOW = params;
		},
		SET_TYPE: (state, params) => {
			state.TYPE = params;
		},
		SET_PAGE_INDEX_FROM: (state, params) => {
			state.PAGE_INDEX_FROM = params;
		},
	},
	actions: {
	}
})
